import { isLdek, isLek } from "../../../../helpers/services";
import ArticleOption from "./Options/Article";
import Comments from "./Options/Comments";
import DiscussionOption from "./Options/Discussion";
import More from "./Options/More";
import Star from "./Options/Star";
import OptionsContainer from "./OptionsContainer";

function DefaultOptionsList({
	details,
	settings,
	question,
	additionalSettings,
	actions,
	dispatch,
}) {
	return (
		<OptionsContainer>
			{(isLek() || isLdek()) && (
				<ArticleOption
					settings={settings}
					details={details}
					question={question}
					additionalSettings={additionalSettings}
					actions={actions}
					dispatch={dispatch}
				/>
			)}
			<DiscussionOption
				settings={settings}
				details={details}
				additionalSettings={additionalSettings}
				actions={actions}
				dispatch={dispatch}
			/>
			<Star
				settings={settings}
				question={question}
				details={details}
				additionalSettings={additionalSettings}
				actions={actions}
				dispatch={dispatch}
			/>
			<Comments
				question={question}
				details={details}
				settings={settings}
				additionalSettings={additionalSettings}
				actions={actions}
				dispatch={dispatch}
			/>
			<More
				settings={settings}
				details={details}
				additionalSettings={additionalSettings}
				question={question}
				actions={actions}
				dispatch={dispatch}
			/>
		</OptionsContainer>
	);
}

export default DefaultOptionsList;
